const Information = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0952 0.00195312H1.90476C0.852952 0.00195312 0 0.854906 0 1.90672V14.0972C0 15.149 0.852952 16.002 1.90476 16.002H14.0952C15.147 16.002 16 15.149 16 14.0972V1.90672C16 0.854906 15.147 0.00195312 14.0952 0.00195312ZM8.7619 12.9543C8.7619 13.1646 8.59124 13.3353 8.38095 13.3353H7.61905C7.40876 13.3353 7.2381 13.1646 7.2381 12.9543V6.09719C7.2381 5.88691 7.40876 5.71624 7.61905 5.71624H8.38095C8.59124 5.71624 8.7619 5.88691 8.7619 6.09719V12.9543ZM8 4.19243C7.47391 4.19243 7.04762 3.76614 7.04762 3.24005C7.04762 2.71395 7.47391 2.28767 8 2.28767C8.5261 2.28767 8.95238 2.71395 8.95238 3.24005C8.95238 3.76614 8.5261 4.19243 8 4.19243Z"
      fill="#1890FF"
    />
  </svg>
)

export default Information
